/**
 * Converts a human-readable duration string into milliseconds
 *
 * @param duration - A string containing hours (h), minutes (m), and/or seconds (s)
 *                  Examples: "1h", "30m", "15s", "1h30m", "1h5m10s"
 * @returns The total duration in milliseconds
 *
 * @example
 * humanDurationToMs("1h")      // returns 3600000
 * humanDurationToMs("1m")      // returns 60000
 * humanDurationToMs("1s")      // returns 1000
 * humanDurationToMs("1h5m10s") // returns 3910000
 */
export function humanDurationToMs(duration: string | number): number {
  if (typeof duration === "number") {
    return duration;
  }

  const MS_PER_SECOND = 1000;
  const MS_PER_MINUTE = MS_PER_SECOND * 60;
  const MS_PER_HOUR = MS_PER_MINUTE * 60;

  const extractNumber = (pattern: RegExp): number => {
    const match = duration.match(pattern);
    return match ? parseInt(match[1], 10) : 0;
  };

  const hours = extractNumber(/(\d+)h/);
  const minutes = extractNumber(/(\d+)m/);
  const seconds = extractNumber(/(\d+)s/);

  return (
    hours * MS_PER_HOUR + minutes * MS_PER_MINUTE + seconds * MS_PER_SECOND
  );
}
